import axios from 'axios';

const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
});

// Attach JWT token from localStorage on each request
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('itanta.token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response && err.response.status === 401) {
      // Token expired / invalid — clear and redirect if we're in an admin route
      if (typeof window !== 'undefined' && window.location.pathname.startsWith('/admin')) {
        localStorage.removeItem('itanta.token');
        localStorage.removeItem('itanta.user');
        window.location.href = '/login';
      }
    }
    return Promise.reject(err);
  }
);

/**
 * Extract a human-readable error message from an axios error.
 *
 * FastAPI returns `detail` as a string for `HTTPException(detail='...')`
 * but as a LIST of Pydantic error objects for 422 validation failures:
 *   [{ type, loc: [...], msg, input, ctx, url }, ...]
 * Rendering that list directly in React throws
 *   "Objects are not valid as a React child".
 *
 * This helper always returns a plain string so callers can safely render it.
 */
export const errorMessage = (err, fallback = 'Something went wrong') => {
  const d = err?.response?.data?.detail;
  if (!d) return err?.message || fallback;
  if (typeof d === 'string') return d;
  if (Array.isArray(d)) {
    return d
      .map((e) => {
        if (typeof e === 'string') return e;
        const msg = e?.msg || e?.message;
        // Last loc segment usually names the offending field (e.g. 'new_password').
        const field = Array.isArray(e?.loc) ? e.loc[e.loc.length - 1] : null;
        if (msg && field) return `${field}: ${msg}`;
        if (msg) return msg;
        return JSON.stringify(e);
      })
      .join(' · ');
  }
  if (typeof d === 'object') {
    return d.msg || d.message || JSON.stringify(d);
  }
  return String(d);
};
